import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthConfigService, CmsConfig, ConfigModule, GlobalMessageService, I18nConfig, I18nModule, NotAuthGuard, provideConfig, RoutingService, UrlModule } from '@spartacus/core';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';
import { ForgotPasswordComponentService } from '@spartacus/user/profile/components';
import {
  customUserProfileTranslationsChunksConfig,
  customUserProfileTranslationsEn,
  customUserProfileTranslationsEs
} from '../../../../../../../../public/translations/custom-user-profile-translation-chunk-config';
import { CustomUserPasswordService } from '../../../core/facades/custom-user-password.service';
import { CustomForgotPasswordComponentService } from './custom-forgot-password-component.service';
import { CustomForgotPasswordComponent } from './custom-forgot-password.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ForgotPasswordComponent: {
          component: CustomForgotPasswordComponent
        }
      }
    } as CmsConfig)
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ForgotPasswordComponent: {
          component: CustomForgotPasswordComponent,
          guards: [NotAuthGuard],
          providers: [
            {
              provide: ForgotPasswordComponentService,
              useClass: CustomForgotPasswordComponentService,
              deps: [CustomUserPasswordService, RoutingService, AuthConfigService, GlobalMessageService]
            }
          ]
        }
      }
    }),
    provideConfig({
      i18n: {
        resources: { en: customUserProfileTranslationsEn, es: customUserProfileTranslationsEs },
        chunks: customUserProfileTranslationsChunksConfig
      }
    } as I18nConfig)
  ],
  declarations: [CustomForgotPasswordComponent]
})
export class CustomForgotPasswordModule {}
